import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  admin_com: number = 0;
  admin_etic: number = 0;

  tip_docum: string = '';
  num_docum: string = '';

  suministro: string = '';
  tipo_solicitante: string = '';
  estado_tramite: string = '';
  existeBand: boolean=false;
  idBandejaGlob: number=0;


  url_navegacion: string = '';

  code_title: number = 0;
  app_title: string = '';

  tipo_form_solicitante: number = 0;

  admin_msg_shared: number = 0;
}
